module.exports = __webpack_public_path__ + "static/media/document.cc8fc9a9.svg";